import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;
const URL = process.env.REACT_APP_BASE_URL_DEVBK;

async function getCityData(isoCode) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCities/${isoCode}`, { headers });
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getStateData(isoCode) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllStates/${isoCode}`, { headers });
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllUsersData() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllActiveUser`, { headers });
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllUsersByAdmin() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllUserByAdmin`, { headers });
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchAllAttendeeList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllParticipants`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function IndustryData() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllIndustry`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getLeadsourceData() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadSource`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getLeadStatusData() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadStatus`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getSeniorityLevelData() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllSeniorityLevel`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCountryData() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCountries`, { headers });
        return response.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getColumnConfigs(value) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/UserDataConfigs/${value}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function SharingPermissions(entity, id, sharingId) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/findSharingForPermission/${entity}/${id}/${sharingId}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function MultiFileUpload(formData) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/uploadMultipleFiles`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getMyTerritory() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/findAllTerritoryByAssignto`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTeamTerritory(value) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/findAllTerritoryByUserId/${value}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getBusinessRuleEntity() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllEntityTypeForAutomation`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTriggerFiledforEntity(name) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllRequestField/${name}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTimeZoneData() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllTimeZone`, { headers });
        const cleanedList = data.data.data.map(item => ({
            ...item,
            timeZone: item.timeZone.replace(/\s\d{2}:\d{2}:\d{2}$/, "")
        }));
        return cleanedList
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCompanyRole() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllCompanyRolesByUser`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllCompanyRoles() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllCompanyRoles`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getSystemRole() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllSystemRoleByAdmin`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getLanguage() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllLanguage`, { headers });
        return data.data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTitle() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllTitle`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAnnualRevenue() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllAnnualRevenue`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getNoofEmployee() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllNomOfEmployee`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getRating() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllRating`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getProdCategory() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllProductCategory`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getUserDepartment() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllDepartment`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getDateFormate() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllDateFormat`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getTimeFormate() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/fetchAllTimeFormat`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchDealByEntity(id, entity) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getRelateEntityData/${id}/${entity}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getScoringDetails(name, id) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/findAllEntityScoringByEntityTypeAndId/${name}/${id}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getMailInfo(company, email) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchDetailUsingEmail/${company}/${email}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FecthModuleEncryptedToken(id, companyId) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/generateTokenUsingId/${id}/${companyId}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FecthModuleDecryptedToken(token, companyId) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/decodeToken/${token}/${companyId}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FecthTableNames() {
    try {
        const data = await getAxiosInstance().get(`/Template/getAllEntityTableName`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function LogOutApi(payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/logOut`, payload, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getsyatemRolePermission(roleId) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/role/${roleId}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function taskReminderAndOverdue() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/taskReminderAndOverdue`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function approvalRequestReminderAndOverdue() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/approvalRequestReminderAndOverdue`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function checkedAccountExpire(headersData) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/checkedAccountExpire`, {
            headers: headersData ?? headers
        });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function triggerMailForExpiredTrialAccount(headersData) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/triggerMailForExpiredTrialAccount`, {
            headers: headersData ?? headers
        });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function triggerMailForExpiringTrialAccount(headersData) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/triggerMailForExpiringTrialAccount`, {
            headers: headersData ?? headers
        });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function login(payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/login`, payload, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function loginFromTwoFactorAuthentication(payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/loginFromTwoFactorAuthentication`, payload, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function forgotPassword(payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/forgotPassword`, payload, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function sendEmailOtpForForgotPassword(email, payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/sendEmailOtpForForgotPassword/${email}`, payload, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function resetNewPassword(email, payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/resetNewPassword/${email}`, payload, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllActivityByType1(apiType, id) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllActivityByType/${apiType}/${id}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllActivityByType(apiType, id, page) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getAllActivityByType/${apiType}/${id}?page=${page}&limit=20`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateActivityStatus(id, status) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/updateActivityStatus/${id}/${status}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function importData(payload) {
    try {
        const response = await getAxiosInstance().post(`/importData/${12345}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function fetchFileAsBufferFile(fileName) {
    try {
        const data = await getAxiosInstance().get(`/importData/fetchFileAsBuffer?fileUrl=${URL}${fileName}`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getBussinesDaysForStaffRole(id, startDate, endDate) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getBussinesDaysForStaffRole/${startDate}/${endDate}/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function importApiCall(apiEndpoint, url, formData) {
    try {
        const response = await getAxiosInstance().post(`${apiEndpoint}${url}`, formData, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findGoalsTargetByUserId(id, year) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findGoalsTargetByUserId/${id}/${year}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findGoalsTargetByUser(year) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findGoalsTargetByUser/${year}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchAllReportiesGoals(year) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllReportiesGoals/${year}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchAllAccountsByOwnerId(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllAccountsByOwnerId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function fetchAllReportiesGoalsByUserId(year, id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllReportiesGoalsByUserId/${year}/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createGoalsTarget(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createGoalsTarget`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateGoalsTarget(payload, glsAdTrtId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateGoalsTarget/${glsAdTrtId}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteGoalsTarget(id) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteGoalsTarget/${id}`, { headers })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function saveUserDataConfig(payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/saveUserDataConfig`, payload, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateUserDataConfig(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/UserDataConfig/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getUserDataConfig(configId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/UserDataConfig/${configId}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getExchangeRate(base, target) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getExchangeRate/${base}/${target}`, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllCurrencies() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllCurrencies`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createCurrency(payload) {
    try {
        const data = await getAxiosInstance().post(`/usermgmt/createCurrency`, payload, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateCurrency(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCurrency/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function leadInsights(companyCode, entityId) {
    try {
        const response = await getAxiosInstance().get(`/leadInsights/${companyCode}/${entityId}`, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function contactInsights(companyCode, entityId) {
    try {
        const response = await getAxiosInstance().get(`/contactInsights/${companyCode}/${entityId}`, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function accountInsights(companyCode, entityId) {
    try {
        const response = await getAxiosInstance().get(`/accountInsights/${companyCode}/${entityId}`, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function dealInsights(companyCode, entityId) {
    try {
        const response = await getAxiosInstance().get(`/dealInsights/${companyCode}/${entityId}`, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function importDemoData() {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/importDemoData`, {}, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    importDemoData,
    leadInsights,
    dealInsights,
    accountInsights,
    contactInsights,
    createCurrency,
    updateCurrency,
    getAllCurrencies,
    saveUserDataConfig,
    updateUserDataConfig,
    getUserDataConfig,
    getExchangeRate,
    getAllCompanyRoles,
    updateGoalsTarget,
    createGoalsTarget,
    deleteGoalsTarget,
    fetchAllReportiesGoals,
    findGoalsTargetByUser,
    findGoalsTargetByUserId,
    fetchAllAccountsByOwnerId,
    fetchAllReportiesGoalsByUserId,
    importApiCall,
    getAllActivityByType1,
    getAllActivityByType,
    updateActivityStatus,
    resetNewPassword,
    forgotPassword,
    sendEmailOtpForForgotPassword,
    login,
    loginFromTwoFactorAuthentication,
    getCityData,
    getStateData,
    getAllUsersData,
    IndustryData,
    getLeadsourceData,
    getLeadStatusData,
    getSeniorityLevelData,
    getCountryData,
    getColumnConfigs,
    SharingPermissions,
    MultiFileUpload,
    FetchAllAttendeeList,
    getMyTerritory,
    getTeamTerritory,
    getBusinessRuleEntity,
    getTriggerFiledforEntity,
    getTimeZoneData,
    getLanguage,
    getSystemRole,
    getCompanyRole,
    getTitle,
    getAnnualRevenue,
    getNoofEmployee,
    getRating,
    getProdCategory,
    getUserDepartment,
    getDateFormate,
    getTimeFormate,
    FetchDealByEntity,
    getScoringDetails,
    getMailInfo,
    getAllUsersByAdmin,
    FecthTableNames,
    FecthModuleDecryptedToken,
    FecthModuleEncryptedToken,
    LogOutApi,
    getsyatemRolePermission,
    taskReminderAndOverdue,
    approvalRequestReminderAndOverdue,
    checkedAccountExpire,
    triggerMailForExpiringTrialAccount,
    triggerMailForExpiredTrialAccount,
    fetchFileAsBufferFile,
    getBussinesDaysForStaffRole,
    importData,
}